// 액션 타입 정의
const TEMPLATE_RESET = 'TEMPLATE_RESET';
const TEMPLATE_ID = 'TEMPLATE_ID';
const HASH = 'HASH';
const TEMPLATE_TITLE = 'TEMPLATE_TITLE';
const TEMPLATE_WIDTH = 'TEMPLATE_WIDTH';
const TEMPLATE_HEIGHT = 'TEMPLATE_HEIGHT';
const TEMPLATE_NAME = 'TEMPLATE_NAME';
// 액션 생섬함수 정의
export const templateReset = () => ({ type: TEMPLATE_RESET });
export const editTemplateId = value => ({
  type: TEMPLATE_ID,
  value
});
export const editHash = value => ({
  type: HASH,
  value
});
export const editTemplateTitle = value => ({
  type: TEMPLATE_TITLE,
  value
});
export const editTemplateName = value => ({
  type: TEMPLATE_NAME,
  value
});
export const editTemplateWidth = value => ({
  type: TEMPLATE_WIDTH,
  value
});
export const editTemplateHeight = value => ({
  type: TEMPLATE_HEIGHT,
  value
});
// 초기상태 정의
const initialState = {
  templateId: null,
  hash: null,
  templateTitle: '',
  templateName: '',
  getFirebaseConfig: false,
  templateWidth: 375,
  templateHeight: 812
};
// 리듀서 작성
export default function templateReducer(state = initialState, action) {
  switch (action.type) {
    case TEMPLATE_RESET:
      return initialState;
    case TEMPLATE_ID:
      return {
        ...state,
        templateId: action.value
      };
    case HASH:
      return {
        ...state,
        hash: action.value
      };
    case TEMPLATE_TITLE:
      return {
        ...state,
        templateTitle: action.value
      };
    case TEMPLATE_NAME:
      return {
        ...state,
        templateName: action.value
      };
    case TEMPLATE_WIDTH:
      return {
        ...state,
        templateWidth: action.value
      };
    case TEMPLATE_HEIGHT:
      return {
        ...state,
        templateHeight: action.value
      };
    default:
      return state;
  }
}
